// extracted by mini-css-extract-plugin
export default {"container":"BoxUi_container__AOrtA"};